export default "__VITE_ASSET__wwvAb_KlS8fN4pEG9patVw__"